<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

    <slide>
        <div class="padding">
        <p>i'm collecting it all, not just these messages, but everything, the words, the city, the lives.</p>
<br>
        <p>Just to try and fix it in place, or at least fix how i see it now, what i know, so i have something to compare, and to show Oska when he's older, and something to cling on to.</p>
<br>
        <p>I've made maps before, for myself of course, like everyone does, but this needs to be more. I need to be able to go back to it and be sure of what I knew.</p>
<br>
        <p>and if I write you into it? what then?</p>
         <p> &nbsp;</p>
        <p> &nbsp;</p>
        </div>
    </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'A Reason'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
